import {useState, useEffect} from 'react';

export function useDeleteButton(show?: boolean) {
  const [showDeleteMessage, setShowDeleteMessage] = useState(false);

  useEffect(() => {
    if (show) {
      setShowDeleteMessage(false);
    }
  }, [show]);

  const onShowDeleteMessage = () => {
    setShowDeleteMessage(!showDeleteMessage);
  };

  return {
    showDeleteMessage,
    onShowDeleteMessage,
  };
}
